/**
 * Feldtypen der Entitäten — Ersatz für
 * `Typ = typeof(TItem).GetProperty(FieldName).PropertyType` aus `IwmBasePageView.GetColumns`.
 * Die Filterzeile schaltet daran ihre Eingabeart.
 *
 * `ColumnValueType` wird hier definiert (und in `components/grid/types.ts` re-exportiert),
 * damit `src/types` nicht von `src/components` abhängt.
 */

import { EntityTypes } from './enums';
import { containerFieldTypes } from './fieldTypes/container';
import { orderPositionFieldTypes } from './fieldTypes/orderPosition';
import { receiptFieldTypes } from './fieldTypes/receipt';
import { receiptAssignmentFieldTypes } from './fieldTypes/receiptAssignment';

export type ColumnValueType = 'string' | 'number' | 'integer' | 'boolean' | 'date';

type FieldTypeMap = Readonly<Record<string, ColumnValueType>>;

const emptyFieldTypes: FieldTypeMap = {};

/**
 * Feldliste je Entität (Reihenfolge wie im Domänenmodell dokumentiert, geerbte
 * `BaseEntity`-Felder am Ende) — Ersatz für `typeof(T).GetProperties()`.
 */
export const containerFieldNames: readonly string[] = Object.keys(containerFieldTypes);
export const orderPositionFieldNames: readonly string[] = Object.keys(orderPositionFieldTypes);
export const receiptFieldNames: readonly string[] = Object.keys(receiptFieldTypes);
export const receiptAssignmentFieldNames: readonly string[] = Object.keys(
  receiptAssignmentFieldTypes,
);

/** Feldtyp-Tabelle einer Entität; für Entitäten ohne Tabelle eine leere Tabelle. */
export function getFieldTypes(entity: EntityTypes): FieldTypeMap {
  switch (entity) {
    case EntityTypes.Bestellposition:
      return orderPositionFieldTypes;
    case EntityTypes.Container:
      return containerFieldTypes;
    case EntityTypes.Rechnung:
      return receiptFieldTypes;
    case EntityTypes.Rechnungszuordnung:
      return receiptAssignmentFieldTypes;
    default:
      return emptyFieldTypes;
  }
}

/** Datentyp eines Feldes; unbekannte Felder gelten als `'string'`. */
export function getFieldValueType(entity: EntityTypes, fieldName: string): ColumnValueType {
  return getFieldTypes(entity)[fieldName] ?? 'string';
}
